/**
 * CustomerInquiry — Mijoz so'rovi (zapchastni bilmaydi) sxemalari.
 *
 * Mijoz qaysi zapchast kerakligini bilmaydi — rasm (xato bo'lishi mumkin),
 * ism/familya/telefon, qachongacha kuta oladi. Do'kon qidirib topadi.
 * Holat: NEW → SEARCHING → FOUND → COMPLETED (yoki CANCELLED).
 */
import { z } from 'zod';
export const INQUIRY_STATUSES = [
    'NEW', // yangi so'rov
    'SEARCHING', // qidirilmoqda
    'FOUND', // topildi
    'SENT', // Telegramga mahsulot(lar) yuborildi
    'REPLIED', // mijoz Telegramda javob yozdi
    'COMPLETED', // mijozga berildi
    'CANCELLED', // bekor
];
/** Telegram username normalize: @, https://t.me/ prefikslarni olib tashlaydi. */
export function normalizeTgUsername(raw) {
    return raw
        .trim()
        .replace(/^https?:\/\/(t\.me|telegram\.me)\//i, '')
        .replace(/^@/, '')
        .replace(/[^A-Za-z0-9_]/g, '');
}
export const createCustomerInquirySchema = z.object({
    customerName: z.string().trim().min(1, 'Mijoz ismi kerak').max(150),
    customerSurname: z.string().trim().max(150).nullable().optional(),
    customerPhone: z.string().trim().max(30).nullable().optional(),
    // Telegram username (@ siz saqlanadi). Bo'lmasa telefon orqali yuboriladi.
    telegramUsername: z.string().trim().max(64).nullable().optional(),
    image: z.string().trim().max(500).nullable().optional(),
    description: z.string().trim().max(1000).nullable().optional(),
    // Mijoz qachongacha kuta oladi (ISO sana yoki sana+soat)
    waitUntil: z.string().datetime({ offset: true }).nullable().optional(),
});
export const updateCustomerInquiryStatusSchema = z.object({
    status: z.enum(INQUIRY_STATUSES),
});
export const customerInquiryQuerySchema = z.object({
    status: z.enum(INQUIRY_STATUSES).optional(),
});
//# sourceMappingURL=customer-inquiry.schema.js.map